export enum SMSTemplates {
    REGISTER = 'Register',
    FORGET_PASSWORD = "ForgotPassword"
}